module.exports = __webpack_public_path__ + "img/sign_apply_type.5980103f.png";